// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"97":"2000da44","683":"5f350619"}[chunkId] + ".css";
};